<section class='page-container goal-step'>
  <!-- display all the steps -->
  <div fxLayout='row' fxFlex fxLayoutGap='10px' class='step-container' *ngIf='!showUpdateStepController'>
    <!-- action to show the status of the step -->
    <span [ngClass]="{'completed': step.status === 'COMPLETED', 'not-completed': step.status !== 'COMPLETED'}">
      <mat-icon (click)='toggleGoalStatusHandler()'>check_circle</mat-icon>
    </span>
    <p>{{step.description}}</p>
    <mat-icon (click)='showUpdateStep()'>edit</mat-icon>
    <mat-icon (click)='deleteStep()' class='delete-btn'>delete_forever</mat-icon>
  </div>

  <form [formGroup]='updateStepForm' fxLayout='column' fxFlex *ngIf='showUpdateStepController'>
    <mat-form-field  appearance='outline' fxFlex>
      <mat-label style="font-size: 18px">What action is needed to complete this goal?</mat-label>
      <input autocomplete="off" style="height: 60px; font-size: 18px" matInput placeholder="What action is needed to complete this goal?" formControlName='description'>
    </mat-form-field>
    <div fxLayout='row' fxLayoutAlign='end center'>
      <button mat-raised-button color='primary' (click)="updateGoal()" [disabled]='disabledAddStepButton'>Update</button>
    </div>
  </form>
</section>
